import React, { useContext, useMemo, useState } from "react";
import Style from "./index.module.scss";
import { Modal, Spin } from "antd";
import { ModalProps } from "antd/es/modal";
import { CourseContext } from "../../../Store";
import useRequest from "../../../../../utils/useRequest";
import {
    adjustRandomGroupMemberQueryNotGroupStudent,
    GroupType,
    queryRandomGroup
} from "../../../../../service/group";
import { GroupSettingsContext } from "../../../GroupSettings/store";
import style from "../../../GroupSettings/index.module.scss";
import GroupsList from "../../../GroupSettings/Components/GroupsList";
import MembersList from "../../../GroupSettings/Components/MembersList";

interface Props extends ModalProps {
    randomGroupKey: string;
    canEdit?: boolean;
    signInId?: number;
}

export interface DoRandomProps {
    groupBySign: boolean;
    groupCount: number;
}
export default function Index({
    randomGroupKey,
    signInId,
    canEdit,
    ...restProps
}: Props) {
    const { course } = useContext(CourseContext);
    const [search, setSearch] = useState(""); //小组列表查询条件
    const [noGroupSearch, setNoGroupSearch] = useState(""); //未分组成员列表查询条件

    //参数列表
    const params = {
        courseNo: course.courseNo,
        courseSeq: course.courseSeq,
        weektimeId: course.weekTimeId
    };

    //小组列表
    const [groupList, { loading: groupListLoading }, updateGroupList] =
        useRequest(
            () =>
                queryRandomGroup({
                    ...params,
                    randomGroupKey
                }),
            {},
            [course, search]
        );

    //未分配小组的学生列表
    const [noGroupStudent, { loading: noGroupLoading }, updateNoGroupStudent] =
        useRequest(
            () =>
                adjustRandomGroupMemberQueryNotGroupStudent({
                    ...params,
                    randomGroupKey
                }),
            {},
            [course]
        );

    //对未分配小组的学生进行筛选
    const filterNoGroupList = useMemo(() => {
        if (!noGroupStudent) return [];
        const search = noGroupSearch.trim();
        return noGroupStudent.filter(item => {
            if (item.name.indexOf(search) !== -1) return true;
            if (item.memberNo === search) return true;
            return false;
        });
    }, [noGroupSearch, noGroupStudent]);
    return (
        <Modal
            title="查看随机分组情况"
            maskClosable={false}
            width={1200}
            footer={null}
            {...restProps}
            className={Style.root}>
            <Spin spinning={groupListLoading}>
                <GroupSettingsContext.Provider
                    value={{
                        groupList,
                        groupListLoading,
                        updateGroupList,
                        setSearch,
                        filterNoGroupList,
                        noGroupLoading,
                        updateNoGroupStudent,
                        setNoGroupSearch
                    }}>
                    <div className={style.container}>
                        <GroupsList
                            signInId={signInId}
                            canEdit={canEdit}
                            type={GroupType.random}
                            randomGroupKey={randomGroupKey}
                        />
                        <MembersList
                            canEdit={canEdit}
                            type={GroupType.random}
                            randomGroupKey={randomGroupKey}
                        />
                    </div>
                </GroupSettingsContext.Provider>
            </Spin>
        </Modal>
    );
}
